import { useEffect, useState } from "react";
import { api } from "../../api";
import { useConsoleTown } from "./ConsoleLayout";

export default function ConsoleResidents() {
  const { town } = useConsoleTown();
  const [rows, setRows] = useState<any[]>([]);
  const [type, setType] = useState("");
  const [q, setQ] = useState("");
  const [selected, setSelected] = useState<any>(null);
  const [error, setError] = useState("");

  const load = () => {
    const query = new URLSearchParams();
    if (type) query.set("type", type);
    if (q.trim()) query.set("q", q.trim());
    api.consoleResidents(town.id, query.toString())
      .then((result) => setRows(result.residents || []))
      .catch((reason) => setError(reason.message || "居民列表加载失败"));
  };
  useEffect(load, [town.id, type]);

  const inspect = async (row: any) => {
    try {
      const result = await api.consoleResident(town.id, row.id);
      setSelected({ ...row, ...result });
    } catch (reason: any) {
      setError(reason.message || "居民详情加载失败");
    }
  };

  const remove = async (row: any) => {
    if (!window.confirm(`确认将「${row.name}」移出本镇？玩家历史数据会保留。`)) return;
    try {
      await api.consoleRemoveResident(town.id, row.id);
      setSelected(null);
      load();
    } catch (reason: any) {
      setError(reason.message || "移出失败");
    }
  };

  const setBan = async (row: any, banned: boolean) => {
    if (!row.userId) return;
    try {
      if (banned) await api.consoleBan(town.id, row.userId);
      else await api.consoleUnban(town.id, row.userId);
      load();
    } catch (reason: any) {
      setError(reason.message || "封禁操作失败");
    }
  };

  return (
    <div className="space-y-5">
      <div className="flex flex-wrap items-center gap-3">
        <h1 className="text-2xl font-black">居民管理</h1>
        <div className="flex-1" />
        <input value={q} onChange={(event) => setQ(event.target.value)} onKeyDown={(event) => event.key === "Enter" && load()} placeholder="搜索名字 / 账号" className="rounded-lg border border-[#d8d2bf] bg-white px-3 py-2 text-sm outline-none focus:border-[#2f6e5b]" />
        <button onClick={load} className="rounded-lg bg-[#2f6e5b] px-4 py-2 text-sm font-bold text-white">搜索</button>
      </div>
      <div className="flex gap-2">
        {[["", "全部"], ["player", "注册玩家"], ["npc", "NPC"], ["guest", "游客"]].map(([value, label]) => (
          <button key={value} onClick={() => setType(value)} className={`rounded-full px-3 py-1.5 text-xs font-bold ${type === value ? "bg-[#2f6e5b] text-white" : "border border-[#d8d2bf] bg-white text-[#665f4f]"}`}>{label}</button>
        ))}
      </div>
      {error && <div className="rounded-lg border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-700">{error}</div>}

      <div className="grid gap-5 xl:grid-cols-[minmax(0,1fr)_340px]">
        <div className="overflow-hidden rounded-xl border border-[#ddd7c4] bg-white shadow-sm">
          <div className="overflow-x-auto">
            <table className="w-full min-w-[760px] text-left text-sm">
              <thead className="bg-[#faf8f2] text-xs text-[#77705f]">
                <tr><th className="px-4 py-3">居民</th><th>类型</th><th>职业</th><th>coin</th><th>fame</th><th>状态</th><th className="pr-4">操作</th></tr>
              </thead>
              <tbody className="divide-y divide-[#f0ecdf]">
                {rows.map((row) => (
                  <tr key={row.id} className={row.isBanned ? "bg-red-50/50" : ""}>
                    <td className="px-4 py-3">
                      <button onClick={() => inspect(row)} className="text-left font-bold hover:text-[#2f6e5b]">{row.name}</button>
                      <div className="text-xs text-[#8b8577]">{row.username || row.id}</div>
                    </td>
                    <td className="py-3">{row.isNpc ? "NPC" : row.isGuest ? "游客" : "玩家"}</td>
                    <td className="py-3">{row.occupation || "-"}</td>
                    <td className="py-3">{Math.round(Number(row.coin || 0))}</td>
                    <td className="py-3">{Math.round(Number(row.fame || 0))}</td>
                    <td className="py-3">{row.isBanned ? <span className="text-red-700">已封禁</span> : <span className="text-emerald-700">正常</span>}</td>
                    <td className="pr-4 py-3">
                      <div className="flex justify-end gap-2">
                        {row.userId && !row.isNpc && (
                          <button onClick={() => setBan(row, !row.isBanned)} className="rounded-md border border-[#d8d2bf] px-2 py-1 text-xs">{row.isBanned ? "解禁" : "封禁"}</button>
                        )}
                        <button onClick={() => remove(row)} className="rounded-md border border-red-200 px-2 py-1 text-xs text-red-700">移出</button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          {!rows.length && <div className="py-16 text-center text-sm text-[#77705f]">没有符合条件的居民</div>}
        </div>

        <aside className="rounded-xl border border-[#ddd7c4] bg-white p-5 shadow-sm">
          <h2 className="font-bold">居民档案</h2>
          {!selected && <p className="mt-3 text-sm text-[#77705f]">点击左侧居民名查看详情。</p>}
          {selected && (
            <div className="mt-4 space-y-3 text-sm">
              <div>
                <div className="font-black">{selected.profile?.name || selected.name}</div>
                <div className="text-xs text-[#77705f]">{selected.profile?.occupation || selected.occupation || "-"}</div>
              </div>
              <div className="rounded-lg bg-[#faf8f2] p-3">
                <div className="text-xs text-[#77705f]">性格</div>
                <div className="mt-1 leading-6">{selected.profile?.personality || selected.personality || "-"}</div>
              </div>
              <div className="rounded-lg bg-[#faf8f2] p-3">
                <div className="text-xs text-[#77705f]">最近记忆</div>
                <div className="mt-1 space-y-2">
                  {(selected.profile?.memories || []).slice(0, 6).map((memory: any, index: number) => (
                    <div key={index} className="text-xs leading-5 text-[#5f594d]">第{memory.day}天 · {memory.content}</div>
                  ))}
                </div>
              </div>
            </div>
          )}
        </aside>
      </div>
    </div>
  );
}
